var render = function render(){var _vm=this,_c=_vm._self._c;return _c('import-component',{attrs:{"model_name":"provider","columns":_vm.columns,"actions":_vm.actions}})
}
var staticRenderFns = []

export { render, staticRenderFns }